import { useState, useEffect, useCallback } from 'react';
import { sessionStorage, localStorage } from 'dibs-browser-storage';

const REGULAR_MARKETING_OPT_IN_PROMO_DISPLAY_VALUE_KEY = 'marketing_optin_display';
const PROMO_DISPLAY_VALUE_KEY = 'intl_marketing_optin_promo_display_value';
const PROMO_DISPLAY_VALUE_CHANGE_EVENT_NAME = 'dibs-intl-marketing-promo-display-value-change';

export const seenRegularMarketingOptIn = (): boolean => {
    const value = localStorage.getItem(REGULAR_MARKETING_OPT_IN_PROMO_DISPLAY_VALUE_KEY);
    return value === 'true' || value === true;
};

export const setSeenRegularMarketingOptIn = (): void => {
    localStorage.setItem(REGULAR_MARKETING_OPT_IN_PROMO_DISPLAY_VALUE_KEY, 'true');
};

export const getPromoDisplayValue = (): string => {
    return (sessionStorage.getItem(PROMO_DISPLAY_VALUE_KEY) as string) || 'HIDDEN';
};

export const setSessionPromoDisplayValue = (value: string): void => {
    sessionStorage.setItem(PROMO_DISPLAY_VALUE_KEY, value);
};

export const clearPromoDisplayValue = (): void => {
    sessionStorage.deleteItem(PROMO_DISPLAY_VALUE_KEY);
};

export const useIntlMarketingOptInPromoDisplayValue = (): [JsonType, (value: string) => void] => {
    const intlPromoDisplayValue = getPromoDisplayValue();

    const [displayValue, setDisplayValue] = useState(intlPromoDisplayValue || 'HIDDEN');

    useEffect(() => {
        function eventHandler(e: CustomEvent): void {
            setDisplayValue(e?.detail?.value);
        }

        window.addEventListener(
            PROMO_DISPLAY_VALUE_CHANGE_EVENT_NAME,
            eventHandler as EventListener
        );

        return () => {
            window.removeEventListener(
                PROMO_DISPLAY_VALUE_CHANGE_EVENT_NAME,
                eventHandler as EventListener
            );
        };
    }, []);

    const setPromoDisplayValue = useCallback((value: string): void => {
        setSessionPromoDisplayValue(value);

        const event = new CustomEvent(PROMO_DISPLAY_VALUE_CHANGE_EVENT_NAME, {
            detail: { value },
        });
        window.dispatchEvent(event);
    }, []);

    return [displayValue, setPromoDisplayValue];
};
